import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: localStorage.getItem('shopName') || '', // Load from LocalStorage
};

const shopSlice = createSlice({
  name: 'shop',
  initialState,
  reducers: {
    setShop: (state, action) => {
      state.name = action.payload;
      localStorage.setItem('shopName', action.payload); // Save to LocalStorage
    },
  },
});

export const { setShop } = shopSlice.actions;
export default shopSlice.reducer;